import React from "react"

import RichTextElement from "@components/StoryBlok/RichTextElement"
import LayoutItem from "@components/V2/Layouts/LayoutItem"

const StoryblokRichTextParagraph = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.RichTextParagraph>) => {
  return (
    <LayoutItem
      mobileGridOrder={mobileGridOrder}
      as="div"
      className="col-span-4 md:col-span-6 lg:col-span-12 [&_b]:font-bold [&_h1]:mb-20 [&_h2]:mb-20 [&_h3]:mb-20 [&_h4]:mb-20 [&_h5]:mb-20 [&_h6]:mb-20 [&_li]:mb-[5px] [&_li_p]:mb-0 [&_ol]:mb-20 [&_ol]:list-decimal [&_ol]:pl-40 [&_p]:mb-20 [&_p]:leading-tight [&_ul]:mb-20 [&_ul]:list-disc [&_ul]:pl-40"
    >
      <RichTextElement
        content={blok.text}
        textColor={blok.textColor}
        className="[&_*]:!text-current"
      />
    </LayoutItem>
  )
}

export default StoryblokRichTextParagraph
